/**
 * Broker client-protection admin client (DEV-3783, Skynet.Accounts). Internal-staff
 * read + upsert over the client-protection policy brokers see. A single policy per
 * company (optionally per sub-company) — so there is no list/create/delete, just
 * get + put.
 *
 * Gated server-side on the same broker-home manage claim as broker announcements;
 * these endpoints 403 until that claim-seed deploys, so callers must degrade
 * gracefully.
 *
 * Get response shape (200): { body, effectiveDate, reportChannelEmail, updatedAt }
 * Get returns 204 (no body) when no policy is set for the company yet.
 */
export class BrokerClientProtectionAdminApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getClientProtection({ companyId, config = {} } = {}) {
    return this.#http.get('/api/admin/brokerClientProtection', {
      ...config,
      params: { companyId },
    });
  }

  async saveClientProtection(body) {
    return this.#http.put('/api/admin/brokerClientProtection', body);
  }
}
